import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

const navItems = [
  { label: "Features", href: "/#features" },
  { label: "How It Works", href: "/#how-it-works" },
  { label: "Teams", href: "/#teams" },
];

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        isScrolled
          ? "border-b border-border bg-background/80 shadow-[0_1px_20px_rgba(0,0,0,0.06)] backdrop-blur-xl"
          : "bg-transparent"
      }`}
    >
      <div className="container mx-auto flex h-20 items-center justify-between">
        <Link to="/" aria-label="ORbiT8 home" className="flex items-center">
          <img src="/images/orbit8-logo.png" alt="ORbiT8" className="h-10 w-auto" />
        </Link>

        <nav
          className="hidden items-center gap-8 font-medium text-foreground md:flex"
          style={{ fontFamily: "'Poppins', sans-serif" }}
        >
          {navItems.map((item) => (
            <a key={item.href} href={item.href} className="transition-colors hover:text-primary">
              {item.label}
            </a>
          ))}
          <Link to="/pricing" className="transition-colors hover:text-primary">
            Pricing
          </Link>
        </nav>

        <div className="flex items-center gap-3">
          <Button
            asChild
            variant="ghost"

            className="font-medium text-foreground hover:bg-primary/5 hover:text-primary"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            <Link to="/login">Sign In</Link>
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
